import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/**
 * 可复用的导航菜单组件
 * @param {Object} props
 * @param {Array} props.menuItems - 菜单配置数组
 * @param {string} props.variant - 样式变体: 'desktop' 或 'mobile'
 * @param {Function} props.onItemClick - 菜单项点击回调
 */
const NavigationMenu = ({ menuItems, variant = 'desktop', onItemClick }) => {
  const { t } = useTranslation();

  const handleClick = (e) => {
    if (onItemClick) {
      onItemClick(e);
    }
  };

  const handleDisabledClick = (e) => {
    e.preventDefault(); // 阻止禁用链接的默认行为
    if (onItemClick) {
      onItemClick(e);
    }
  };

  return (
    <ul className={`nav-menu nav-menu--${variant}`}>
      {menuItems.map((item) => (
        <li key={item.id} className="nav-item dropdown">
          {item.disableLink ? (
            // 禁用链接的导航项，显示为span
            <span 
              className="nav-link-disabled"
              style={{ cursor: 'default' }}
            >
              {t(item.labelKey)}
            </span>
          ) : item.isLink ? (
            <Link
              to={item.href}
              target={item.target}
              rel={item.rel}
              onClick={handleClick}
            >
              {t(item.labelKey)}
            </Link>
          ) : (
            <a href={item.href} onClick={handleClick}>
              {t(item.labelKey)}
            </a>
          )}
          
          {item.subItems && item.subItems.length > 0 && (
            <ul className="dropdown-menu">
              {item.subItems.map((subItem) => (
                <li key={subItem.id}>
                  {subItem.isLink ? (
                    <Link to={subItem.href} onClick={handleClick}>
                      {t(subItem.labelKey)}
                    </Link>
                  ) : (
                    <a href={subItem.href} onClick={handleClick}>
                      {t(subItem.labelKey)}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          )}
        </li>
      ))}
    </ul>
  );
};

export default NavigationMenu;
